goog.provide('el8.appchart.dialog.growthChart');

goog.require('el8.shared.util.renderGrowthChart');
goog.require('el8.uiwidget.NewDialog');
goog.require('el8.service.urls');
goog.require('el8.template.appchart.dialog.growthChart');
goog.require('el8.service.tooltip');

el8.appchart.dialog.growthChart = (function() {

    var MIN_DIALOG_WIDTH = 900;

    var groupedNav = null;


    var that = new el8.uiwidget.NewDialog({
        title: 'Growth Charts',
        width: function() {
            // take up to 0.7 * the app width but take up at least MIN_DIALOG_WIDTH
            return Math.max(MIN_DIALOG_WIDTH, Math.floor(0.7*el8.app.pageLayout.getAppInnerWidth()));
        },
        position: 'center',
        height: function() {
            // take the whole available chart height, excluding the write/see bar
            return el8.app.pageLayout.getChartInnerHeight();
        },
        contentFn: function() {
            return el8.template.appchart.dialog.growthChart.content();
        },
        showXButton: true
    });

    var super_init = that._init;
    that._init = function() {
        super_init.call(that);

        groupedNav = new el8.uiwidget.GroupedNav({
            navContainer: $('.growth-chart-nav', that.getContentElt()),
            contentContainer: $('.growth-chart-content', that.getContentElt())
        });
        groupedNav.init({ groups: createGrowthChartGroups() });

        that.getContentElt().on('click', '.print-trigger',  function() {
            var showingChart = groupedNav.getShowingSection(); // names should all be "dataSrc-Vital"
            var url = el8.service.urls.get('printGrowthChart', showingChart.split('-'));
            window.open(url);
        });

        that.getContentElt().on('click', '.refresh-trigger',  function() {
            groupedNav.showSection(groupedNav.getShowingSection());
        });
    };

    var super_show = that.show;
    that.show = function() {
        var ptSex = el8.ptdata.currPatient.getSex();
        if (ptSex !== 'M' && ptSex !== 'F') {
            el8.uiwidget.alert('Growth charts are only available for Male or Female patients.');
            that.hide();
            return;
        }

        super_show.call(that);
        if (el8.ptdata.currPatient.getAge() < 2) {
            groupedNav.showSection('who-height');
        } else {
            groupedNav.showSection('cdc-height');
        }
    };

    var super_hide = that.hide;
    that.hide = function() {
        $('.el8GrowthChartDataAnchor', that.getContentElt()).each(function(i, tooltipAnchor) {
            el8.service.tooltip.destroy($(tooltipAnchor));
        });
        super_hide.call(that);
    };


    function doLoadGraph($container, name) {
        var graphWidth = that.getContentElt().width() - 200;
        var graphHeight = Math.floor(0.75 * graphWidth);

        var containerId = 'react-growth-chart-' + name;
        var $graph = $('.chart-holder', $container)
          .attr('id', containerId)
          .outerHeight(graphHeight)
          .outerWidth(graphWidth)
          .addClass('dataLoading');

        $.el8_ajax({
            url: el8.service.urls.get('growthChart', name.split('-')), // names should all be "dataSrc-Vital"
            type: 'GET',
            success: function(data) {
                $graph.removeClass('dataLoading');
                el8React.render.growthChart(containerId, {
                  data: data,
                  height: graphHeight,
                  width: graphWidth
                });
                that.adjustHeight();
            }
        });
    }

    function createGrowthChartGroups() {
        var initFn = function($container, name) {
            $container.html(el8.template.appchart.dialog.growthChart.chartHolder());
        };

        return [
            {
                title: '0-24 months (WHO)',
                sections: [
                    {
                        name: 'who-height',
                        label: 'Height for Age',
                        initFn: initFn,
                        showFn: doLoadGraph
                    },
                    {
                        name: 'who-weight',
                        label: 'Weight for Age',
                        initFn: initFn,
                        showFn: doLoadGraph
                    },
                    {
                        name: 'who-hc',
                        label: 'Head Circumference for Age',
                        initFn: initFn,
                        showFn: doLoadGraph
                    }
                ]
            },
            {
                title: '2-20 years (CDC)',
                sections: [
                    {
                        name: 'cdc-height',
                        label: 'Height for Age',
                        initFn: initFn,
                        showFn: doLoadGraph
                    },
                    {
                        name: 'cdc-weight',
                        label: 'Weight for Age',
                        initFn: initFn,
                        showFn: doLoadGraph
                    },
                    {
                        name: 'cdc-bmi',
                        label: 'BMI for Age',
                        initFn: initFn,
                        showFn: doLoadGraph
                    },
                ]
            },
            {
                title: 'Pre-Term',
                sections: [
                    {
                        name: 'premie-height',
                        label: 'Height for Age',
                        initFn: initFn,
                        showFn: doLoadGraph
                    },
                    {
                        name: 'premie-weight',
                        label: 'Weight for Age',
                        initFn: initFn,
                        showFn: doLoadGraph
                    },
                    {
                        name: 'premie-hc',
                        label: 'Head Circumference for Age',
                        initFn: initFn,
                        showFn: doLoadGraph
                    }
                ]
            },
            {
                title: 'Down Syndrome (0-36 months)',
                sections: [
                    {
                        name: 'dsinfant-height',
                        label: 'Height for Age',
                        initFn: initFn,
                        showFn: doLoadGraph
                    },
                    {
                        name: 'dsinfant-weight',
                        label: 'Weight for Age',
                        initFn: initFn,
                        showFn: doLoadGraph
                    },
                    {
                        name: 'dsinfant-hc',
                        label: 'Head Circumference for Age',
                        initFn: initFn,
                        showFn: doLoadGraph
                    }
                ]
            },
            {
                title: 'Down Syndrome (2-20 years)',
                sections: [
                    {
                        name: 'ds-height',
                        label: 'Height for Age',
                        initFn: initFn,
                        showFn: doLoadGraph
                    },
                    {
                        name: 'ds-weight',
                        label: 'Weight for Age',
                        initFn: initFn,
                        showFn: doLoadGraph
                    },
                    {
                        name: 'ds-bmi',
                        label: 'BMI for Age',
                        initFn: initFn,
                        showFn: doLoadGraph
                    },
                    {
                        name: 'ds-hc',
                        label: 'Head Circumference for Age',
                        initFn: initFn,
                        showFn: doLoadGraph
                    }
                ]
            }

        ];
    }

    return that;

})();
